"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentReasonPanelWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var services_1 = require("@falcon/services");
var HeadsUpPanel_1 = require("../../components/HeadsUpPanel");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../commonFunctions");
var BasePaymentReasonPanel_1 = require("./BasePaymentReasonPanel");
var PaymentReasonPanelWidget = /** @class */ (function (_super) {
    __extends(PaymentReasonPanelWidget, _super);
    function PaymentReasonPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.findPreviousPolicyInteraction = function () {
            var previousPolicies = [];
            var interactionVehicleRegistrationNumber = _this.props.interaction.vehicles[0].registrationNumber;
            if (_this.state.policies && _this.state.policies.length > 0) {
                _this.state.policies.forEach(function (policy) {
                    if (policy.status !== services_1.POLICY_STATUS_MTC && policy.interaction.vehicles &&
                        policy.interaction.vehicles[0].registrationNumber === interactionVehicleRegistrationNumber &&
                        policy.policyNumber === _this.props.interaction.agreementNumber) {
                        previousPolicies.push(policy);
                    }
                });
            }
            return previousPolicies.length > 0 ? previousPolicies[0].interaction : previousPolicies;
        };
        _this.wordingForSingleAddonOrExcessChange = function (results) {
            var mapping = [
                { key: "courtesyCar", value: "Guaranteed hire car" },
                { key: "legalProtection", value: "Motor legal expenses" },
                { key: "voluntaryExcess", value: "Voluntary excess" }
            ];
            var vehicle = _this.props.interaction.vehicles[0];
            var differentField = results[0];
            var wordingToShow = mapping.find(function (wording) { return (wording === null || wording === void 0 ? void 0 : wording.key) === (differentField === null || differentField === void 0 ? void 0 : differentField.key); });
            var wordingForPopup = wordingToShow.key === "voluntaryExcess" ? "changing your excess to \u00A3".concat(differentField.state) : "".concat(differentField.state ? "adding" : "removing", " ").concat(wordingToShow.value);
            var wordingForHeadsUpPanel = wordingToShow.key === "voluntaryExcess" ? "changed your excess to \u00A3".concat(differentField.state) : "".concat(differentField.state ? "added" : "removed", " ").concat(wordingToShow.value);
            var wordingForPaymentReason = wordingToShow.key === "voluntaryExcess" ? "change your excess to \u00A3".concat(differentField.state) : "".concat(differentField.state ? "add" : "remove", " ").concat(wordingToShow.value);
            window.sessionStorage.setItem("mtaSuccessMessageText", wordingForPopup);
            window.sessionStorage.setItem("mtaHeadsUpMessageText", wordingForHeadsUpPanel);
            var prefix = "";
            if (wordingToShow.key === "voluntaryExcess") {
                prefix = "on";
            }
            else {
                if (!differentField.state) {
                    prefix = "from";
                }
                else {
                    prefix = "to";
                }
            }
            return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)("p", { children: "to ".concat(wordingForPaymentReason, " ").concat(prefix, " ").concat(vehicle.make, ", ").concat(vehicle.model, " (").concat(vehicle.registrationNumber, ")") }) }));
        };
        _this.wordingForAnyOtherChangesMade = function () {
            var genericMessage = "for the changes you have made";
            window.sessionStorage.setItem("mtaHeadsUpMessageText", "genericMessage");
            return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)("p", { children: genericMessage }) }));
        };
        _this.renderPaymentReasonMessage = function () {
            if (_this.state.policies && _this.state.policies.length > 0 && _this.state.subscription && _this.state.policiesLoaded) {
                var interaction = _this.props.interaction;
                var previousPolicyInteraction = _this.findPreviousPolicyInteraction();
                var policyInteractionPolicyHolder = (0, commonFunctions_1.flattenObjectJson)(previousPolicyInteraction.policyHolder);
                var interactionPolicyHolder = (0, commonFunctions_1.flattenObjectJson)(interaction.policyHolder);
                var addonsOrExcessesChanged = _this.getAddonsOrExcessesChanged(previousPolicyInteraction);
                var additionalQuestionsChanged = _this.getAdditionalQuestionsChangedCount(previousPolicyInteraction);
                var policyHolderFieldsChanged = (0, commonFunctions_1.getDriverFieldsChangedCount)(interactionPolicyHolder, policyInteractionPolicyHolder);
                var isAdditionalDriverEdited = _this.isAdditionalDriverEdited(previousPolicyInteraction, interaction);
                var totalFieldsChanged = addonsOrExcessesChanged.length + additionalQuestionsChanged + policyHolderFieldsChanged;
                var displayMessage = void 0;
                if (totalFieldsChanged === 1 && addonsOrExcessesChanged.length === 1 && !isAdditionalDriverEdited) {
                    displayMessage = (0, jsx_runtime_1.jsx)("div", { children: _this.wordingForSingleAddonOrExcessChange(addonsOrExcessesChanged) });
                }
                else {
                    displayMessage = (0, jsx_runtime_1.jsx)("div", { children: _this.wordingForAnyOtherChangesMade() });
                }
                var wordingForHeadsUpPanel = (0, jsx_runtime_1.jsxs)("div", { className: "text-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "pb-2", children: _this.amountToDisplay() }), displayMessage] });
                return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)(HeadsUpPanel_1.HeadsUpPanel, { wordingHtml: wordingForHeadsUpPanel, interaction: interaction, subscription: _this.state.subscription, policies: _this.state.policies }) }));
            }
            else {
                return "";
            }
        };
        _this.isAdditionalDriverEdited = function (policyInteraction, interaction) {
            var result = false;
            if ((policyInteraction.additionalDrivers && interaction.additionalDrivers) && (policyInteraction.additionalDrivers.length === interaction.additionalDrivers.length)) {
                var policyInteractionAdditionalDrivers_1 = _this.flattenAdditionalDriversObject(policyInteraction.additionalDrivers);
                var interactionAdditionalDrivers_1 = _this.flattenAdditionalDriversObject(interaction.additionalDrivers);
                var fieldsChanged_1 = 0;
                interactionAdditionalDrivers_1.forEach(function (driver, index) {
                    fieldsChanged_1 += (0, commonFunctions_1.getDriverFieldsChangedCount)(interactionAdditionalDrivers_1[index], policyInteractionAdditionalDrivers_1[index]);
                });
                result = fieldsChanged_1 > 0;
            }
            if (policyInteraction.additionalDrivers && !interaction.additionalDrivers) {
                result = false;
            }
            return result;
        };
        _this.flattenAdditionalDriversObject = function (additionalDriverObject) {
            var resultArray = [];
            additionalDriverObject.forEach(function (driver) {
                var flattenedDriverObject = (0, commonFunctions_1.flattenObjectJson)(driver);
                resultArray.push(flattenedDriverObject);
            });
            return resultArray;
        };
        _this.getAddonsOrExcessesChanged = function (previousPolicyInteraction) {
            var _a, _b, _c, _d, _e, _f;
            var previousPolicyInteractionVehicle = previousPolicyInteraction.vehicles[0];
            var interaction = _this.props.interaction;
            var vehicle = interaction.vehicles[0];
            var interactionAddonsAndExcesses = [
                { key: "courtesyCar", state: (_a = vehicle.extraProtection) === null || _a === void 0 ? void 0 : _a.courtesyCar },
                { key: "legalProtection", state: (_b = vehicle.extraProtection) === null || _b === void 0 ? void 0 : _b.legalProtection },
                { key: "voluntaryExcess", state: (_c = vehicle.excesses) === null || _c === void 0 ? void 0 : _c.voluntaryExcess }
            ];
            var policyAddonsAndExcesses = [
                { key: "courtesyCar", state: (_d = previousPolicyInteractionVehicle.extraProtection) === null || _d === void 0 ? void 0 : _d.courtesyCar },
                { key: "legalProtection", state: (_e = previousPolicyInteractionVehicle.extraProtection) === null || _e === void 0 ? void 0 : _e.legalProtection },
                { key: "voluntaryExcess", state: (_f = previousPolicyInteractionVehicle.excesses) === null || _f === void 0 ? void 0 : _f.voluntaryExcess }
            ];
            var results = [];
            interactionAddonsAndExcesses.forEach(function (i) {
                var differedValue = policyAddonsAndExcesses.find(function (policy) {
                    return (policy.key === i.key) && (policy.state !== i.state);
                });
                if (differedValue) {
                    results.push(i);
                }
            });
            return results;
        };
        _this.getAdditionalQuestionsChangedCount = function (policyInteraction) {
            var interaction = _this.props.interaction;
            var interactionVehicle = interaction.vehicles[0];
            var policyInteractionVehicle = policyInteraction.vehicles[0];
            var objectCarInteraction = [
                { key: "purchaseDate", value: interactionVehicle.purchaseDate },
                { key: "mileage", value: interactionVehicle.mileage },
                { key: "overnightLocationIsHome", value: interactionVehicle.overnightLocationIsHome },
                { key: "hasModifications", value: interactionVehicle.hasModifications }
            ];
            var objectCarPolicyInteraction = [
                { key: "purchaseDate", value: policyInteractionVehicle.purchaseDate },
                { key: "mileage", value: policyInteractionVehicle.mileage },
                { key: "overnightLocationIsHome", value: policyInteractionVehicle.overnightLocationIsHome },
                { key: "hasModifications", value: policyInteractionVehicle.hasModifications }
            ];
            var results = [];
            objectCarInteraction.forEach(function (interactionCar) {
                var differedValue = objectCarPolicyInteraction.find(function (polInt) {
                    return (interactionCar.key === polInt.key) && (interactionCar.value !== polInt.value);
                });
                if (differedValue) {
                    results.push(policyInteraction);
                }
            });
            return results.length;
        };
        _this.state = {
            policies: [],
            policiesLoaded: false,
            party: null,
            partyLoaded: false,
            subscriptionLoaded: false,
            subscription: null
        };
        return _this;
    }
    PaymentReasonPanelWidget.prototype.render = function () {
        var loading = !(this.state.policiesLoaded && this.state.partyLoaded && this.state.subscriptionLoaded);
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [this.renderPaymentReasonMessage(), (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: loading })] }));
    };
    PaymentReasonPanelWidget = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], PaymentReasonPanelWidget);
    return PaymentReasonPanelWidget;
}(BasePaymentReasonPanel_1.BasePaymentReasonPanel));
exports.PaymentReasonPanelWidget = PaymentReasonPanelWidget;
//# sourceMappingURL=PaymentReasonPanelWidget.js.map